module.exports = __webpack_public_path__ + "static/img_0-9aec8c167fc91f3b5fce88339eea72e5.png";